import React from 'react'
import '@splidejs/splide/dist/css/splide.min.css'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import './Explore.css'
import { Col, Container, Row } from 'react-bootstrap'

function Explore() {
  return (
    <>
      <div
        id="appCapsule"
        style={{ marginTop: '50px', justifyContent: 'center', display: 'flex' }}
      >
        {/* <div class="header-large-title">
          <h1 class="title">Discover</h1>
          <h4 class="subtitle">Welcome to Explore</h4>
        </div>

        <Container className="d-flex flex-column gap-5 my-4">
          <Row>
            <Col>
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Facebook.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Facebook</div>
                </div>
              </a>
            </Col>
            <Col>
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Whatsapp.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Whatsapp</div>
                </div>
              </a>
            </Col>
            <Col className="d-flex justify-content-center">
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Instagram.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Instagram</div>
                </div>
              </a>
            </Col>
            <Col className="d-flex justify-content-center">
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/webweb.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>WebWeb</div>
                </div>
              </a>
            </Col>
          </Row>
          <Row>
            <Col>
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Facebook.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Facebook</div>
                </div>
              </a>
            </Col>
            <Col>
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Whatsapp.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Whatsapp</div>
                </div>
              </a>
            </Col>
            <Col className="d-flex justify-content-center">
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Instagram.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Instagram</div>
                </div>
              </a>
            </Col>
            <Col className="d-flex justify-content-center">
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/webweb.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>WebWeb</div>
                </div>
              </a>
            </Col>
          </Row>
          <Row>
            <Col>
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Facebook.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Facebook</div>
                </div>
              </a>
            </Col>
            <Col>
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Whatsapp.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Whatsapp</div>
                </div>
              </a>
            </Col>
            <Col className="d-flex justify-content-center">
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/Instagram.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>Instagram</div>
                </div>
              </a>
            </Col>
            <Col className="d-flex justify-content-center">
              <a href="#" class="item">
                <img
                  src={`assets/img/apps/webweb.svg`}
                  alt="app-icon"
                  className="icon-image "
                />
                <div class="in">
                  <div>WebWeb</div>
                </div>
              </a>
            </Col>
          </Row>
        </Container>
        <div class="header-large-title pt-5">
          <h4 class="subtitle">App list View</h4>
        </div>
        <ul class="listview image-listview">
          <li>
            <a href="#" class="item">
              <img
                src={`assets/img/apps/Whatsapp.svg`}
                alt="app-icon"
                className="icon-image me-1"
              />
              <div class="in">
                <div>Whatsapp</div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" class="item">
              <img
                src={`assets/img/apps/Facebook.svg`}
                alt="app-icon"
                className="icon-image me-1"
              />
              <div class="in">
                <div>Facebook</div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" class="item">
              <img
                src={`assets/img/apps/Instagram.svg`}
                alt="app-icon"
                className="icon-image me-1"
              />
              <div class="in">
                <div>Instagram</div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" class="item">
              <img
                src={`assets/img/apps/webweb.svg`}
                alt="app-icon"
                className="icon-image me-1"
              />
              <div class="in">
                <div>WebWeb</div>
              </div>
            </a>
          </li>
        </ul>
        <div class="header-large-title pt-5">
          <h4 class="subtitle">Cards</h4>
        </div>
        <div class="section full  mb-3 p-1">
          <Splide
            options={{
              type: 'loop',
              perPage: 3,
              gap: '19rem',
              breakpoints: {
                768: {
                  perPage: 2, // 1 slide per page for screens ≤ 768px
                  gap: '0.5rem' // Even smaller gap
                }
              },
              pagination: false,
              arrows: false
            }}
          >
            <SplideSlide>
              <div class="card product-card">
                <div class="card-body">
                  <img src="imgtest.jpg" class="image" alt="product image" />
                  <h2 class="title">Apple</h2>
                  <p class="text">1 kg</p>
                  <div class="price">$ 4.99</div>
                  <a href="#" class="btn btn-sm btn-primary btn-block">
                    ADD TO CART
                  </a>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div class="card product-card">
                <div class="card-body">
                  <img src="imgtest.jpg" class="image" alt="product image" />
                  <h2 class="title">Apple</h2>
                  <p class="text">1 kg</p>
                  <div class="price">$ 4.99</div>
                  <a href="#" class="btn btn-sm btn-primary btn-block">
                    ADD TO CART
                  </a>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div class="card product-card">
                <div class="card-body">
                  <img src="imgtest.jpg" class="image" alt="product image" />
                  <h2 class="title">Apple</h2>
                  <p class="text">1 kg</p>
                  <div class="price">$ 4.99</div>
                  <a href="#" class="btn btn-sm btn-primary btn-block">
                    ADD TO CART
                  </a>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div class="card product-card">
                <div class="card-body">
                  <img src="imgtest.jpg" class="image" alt="product image" />
                  <h2 class="title">Apple</h2>
                  <p class="text">1 kg</p>
                  <div class="price">$ 4.99</div>
                  <a href="#" class="btn btn-sm btn-primary btn-block">
                    ADD TO CART
                  </a>
                </div>
              </div>
            </SplideSlide>
          </Splide>
        </div> */}
        <h2 className="soon mt-5">
          <i>Coming Soon</i>
        </h2>
      </div>
    </>
  )
}

export default Explore
